// extracted by mini-css-extract-plugin
export default {"formSubmit":"FormSubmit-module__formSubmit___H8sCC"};